import { BlockModel, BlockType } from '@empathy/survey/base';

export interface ListBlockRenderRow {
  blockIndex: number;
  id: string;
  subBlocks: ListBlockSubBlockView[];
  title: string;
  type: BlockType;
}

export interface ListBlockSubBlockView {
  id: string;
  title: string;
  type: BlockType;
}

export const buildListBlockRenderModel = (blocks: BlockModel[]): ListBlockRenderRow[] => {
  const blockById = buildIndex(blocks);

  return blocks
    .map((block, blockIndex) => ({ block, blockIndex }))
    .filter(({ block }) => !block.isSubBlock)
    .map(({ block, blockIndex }) => ({
      blockIndex,
      id: block.id,
      subBlocks: buildSubBlockViews(block, blockById),
      title: block.title,
      type: block.type
    }));
};

export const takeBlocks = (rows: ListBlockRenderRow[], blockCount: number): ListBlockRenderRow[] => {
  const visibleRows: ListBlockRenderRow[] = [];
  let remainingBlocks = blockCount;

  for (const row of rows) {
    if (remainingBlocks <= 0) {
      break;
    }

    remainingBlocks--;
    const visibleSubBlocks = row.subBlocks.slice(0, remainingBlocks);

    visibleRows.push({ ...row, subBlocks: visibleSubBlocks });
    remainingBlocks -= visibleSubBlocks.length;
  }

  return visibleRows;
};

export const countBlocks = (rows: ListBlockRenderRow[]): number => rows.reduce((total, row) => total + 1 + row.subBlocks.length, 0);

const buildSubBlockViews = (block: BlockModel, blockById: Map<string, BlockModel>): ListBlockSubBlockView[] =>
  (block.groupedBlockIds ?? [])
    .map((subBlockId) => blockById.get(subBlockId))
    .filter((subBlock) => !!subBlock)
    .map((subBlock) => ({ id: subBlock.id, title: subBlock.title, type: subBlock.type }));

const buildIndex = (blocks: BlockModel[]): Map<string, BlockModel> => {
  const blockById = new Map<string, BlockModel>();
  blocks.forEach((block) => blockById.set(block.id, block));

  return blockById;
};
